import { UserType } from '@metadevprofile/shared';
import { Button } from '@metadevprofile/ui/web';
import { LogOutIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { selectImpersonationActive, selectImpersonationTargetUser } from '@/admin-user/stores/impersonation-slice';
import { stopImpersonation } from '@/admin-user/stores/usecases/impersonation/stop-impersonation';
import { useAppSelector } from '@/common/redux/store';

export function ImpersonationBanner() {
  const { t } = useTranslation('admin-user', { keyPrefix: 'impersonation' });
  const active = useAppSelector(selectImpersonationActive);
  const targetUser = useAppSelector(selectImpersonationTargetUser);

  if (!active || !targetUser) return null;

  const typeLabel = targetUser.type === UserType.INSTITUTION ? t('roles.institution') : t('roles.practitioner');

  return (
    <div className="sticky top-0 z-50 flex items-center justify-center gap-3 bg-warning px-4 py-2 text-sm font-medium text-warning-foreground">
      <span>{t('banner', { email: targetUser.email, type: typeLabel })}</span>
      <Button
        size="sm"
        variant="outline"
        className="h-7 border-warning-foreground/30 bg-warning text-warning-foreground hover:bg-warning/90"
        onPress={() => stopImpersonation()}
      >
        <LogOutIcon className="h-3.5 w-3.5 mr-1.5" />
        {t('quit')}
      </Button>
    </div>
  );
}
